import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import { DataCell, CommonModal } from '../../TableUIKit';
import { useVoiceApi } from '../../auth/helper/api/voiceApi';

const VoiceTemplatePage = () => {

  const voiceApi = useVoiceApi();
  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState([]); // State for categories
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [newTemplate, setNewTemplate] = useState({
    voiceTemplateId: '',
    voiceTemplateName: '',
    voiceTemplate: '',
    voiceTemplateStatus: true,
    voiceTemplateStage: '',
    voiceTemplateCategory: null,
    categoryId: '',
  });
  const [editingTemplate, setEditingTemplate] = useState(null); // Track which tempalte is being edited
  const [editVoiceTemplateStage, setEditSmsTemplateStage] = useState("");

  // State for filters
  const [filters, setFilters] = useState({
    id: null,
    voiceTemplateId: '',
    voiceTemplateName: '',
    voiceTemplateStatus: true,
    voiceTemplateStage: '',
    voiceTemplateCategory: null,
  });

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  const [activeDetails, setActiveDetails] = useState(null);


  useEffect(() => {

    const fetchTemplates = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_TEMPLATES_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters,
              page,
              size,
            },
          }
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setTemplates(object.content); // Set the templates from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching templates:', err);
        setError(err.message || 'An unexpected error occurred.'); // Provide error message to state
        setLoading(false);
      }
    };

    const fetchCategories = async () => {

      try {
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_CATEGORIES_ENDPOINT
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setCategories(object); // Set the templates from the response object
          console.log('categories:', categories);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        setLoading(false);

      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'Failed to load categories.');
        setLoading(false);
      }
    };

    fetchTemplates();
    fetchCategories();
  }, [voiceApi, page, size]); // Dependency array is empty to run this effect once after the component mounts

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Special handling for category dropdown
    if (name === 'categoryId') {
      const selectedCategory = categories.find(
        (c) => String(c.id) === String(value)    // or match on templateCategory if needed
      );

      setNewTemplate((prev) => ({
        ...prev,
        categoryId: value,
        voiceTemplateCategory: selectedCategory || null, // full object
      }));
      return;
    }

    // Default handling (including checkboxes)
    setNewTemplate((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  const handleEditClick = (template) => {
    // Set the template being edited
    setEditingTemplate(template.id);
    setEditSmsTemplateStage(template.voiceTemplateStage || "");
  };

  const handleEditSubmit = async (templateId) => {

    try {
      // Update template with PUT request

      await voiceApi.put(
        `${process.env.REACT_APP_PUT_VOICE_TEMPLATE_ENDPOINT}/${templateId}`,
        {
          voiceTemplateStage: editVoiceTemplateStage,
        }
      );

      // Refresh the templates list after the update
      const updatedTemplates = templates.map((template) => {
        if (template.id === templateId) {
          return { ...template, voiceTemplateStage: editVoiceTemplateStage }; // Update the edited template
        }
        return template; // Keep the other records unchanged
      });
      setTemplates(updatedTemplates);
      setEditingTemplate(null); // Reset editing state
      setEditSmsTemplateStage('')//clear
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Template.');
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      console.log("newTempalte: ", newTemplate);
      const response = await voiceApi.post(
        `${process.env.REACT_APP_SET_VOICE_TEMPLATE_ENDPOINT}`,
        newTemplate
      );
      if (response.status === 200) {
        setTemplates((prev) => [...prev, response.data.object]); // Append the new template
        setNewTemplate({
          voiceTemplateId: '',
          voiceTemplateName: '',
          voiceTemplate: '',
          voiceTemplateStatus: true,
          voiceTemplateStage: '',
          voiceTemplateCategory: '',
          categoryId: '',
        });
        setError(null); // Clear any previous errors
        setModalOpen(false); // Close modal after submission
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while creating the template.');
    }
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, voiceTemplateStatus: statusValue };
      return newFilters;
    });
  };

  const toggleActivationStatus = async (templateId, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle activation status
      await voiceApi.patch(
        `${process.env.REACT_APP_SET_VOICE_TEMPLATE_STATUS_ENDPOINT}/${templateId}`,
        { status: newStatus }
      );
      // Update the local state after toggling the status
      setTemplates((prev) => prev.map(template =>
        template.id === templateId ? { ...template, voiceTemplateStatus: newStatus } : template
      ));
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {
      const response = await voiceApi.get(
        process.env
          .REACT_APP_GET_ALL_VOICE_TEMPLATES_BY_PAGE_ENDPOINT,
        {
          params: {
            ...filters,
            page,
            size,
          },
        }
      );

      // Extract data from the response
      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) { // Check for successful status
        setTemplates(object.content); // Set the templates from the response object
        setTotalPages(object.totalPages);
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching templates:', err);
      setError(err.message || 'An unexpected error occurred.'); // Provide error message to state
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading templates: {error}</div>;

  return (
    <div className="template-table">
      <h2>Voice Templates</h2>
      <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>

      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>Id:</label>
          <input
            type="text"
            name="id"
            value={filters.id ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>voiceTemplateId:</label>
          <input
            type="text"
            name="voiceTemplateId"
            value={filters.voiceTemplateId ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>smsTemplateName:</label>
          <input
            type="text"
            name="voiceTemplateName"
            value={filters.voiceTemplateName ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>voiceTemplateStage:</label>
          <input
            type="text"
            name="voiceTemplateStage"
            value={filters.voiceTemplateStage ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Status:</label>
          <select name="voiceTemplateStatus" onChange={handleStatusChange} value={filters.voiceTemplateStatus === null ? '' : filters.voiceTemplateStatus ? 'Active' : 'Inactive'}>
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div className="filter-item">
          <label>voiceTemplateCategory:</label>
          <input
            type="text"
            name="voiceTemplateCategory"
            value={filters.voiceTemplateCategory ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      {/* Button to open the modal */}
      <button onClick={() => setModalOpen(true)}>+ Create New</button>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="page-container">
          <h3>Create New Voice Template</h3>
          {/* Form for creating a new Voice Template */}
          <form onSubmit={handleSubmit}  className="standard-form">
            <div className="form-group">
              <label>Voice Template ID:</label>
              <input
                type="text"
                name="voiceTemplateId"
                value={newTemplate.voiceTemplateId}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Voice Template Name:</label>
              <input
                type="text"
                name="voiceTemplateName"
                value={newTemplate.voiceTemplateName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Category:</label>
              <select
                name="categoryId"
                value={newTemplate.categoryId}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a category</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.templateCategory}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Voice Template Body:</label>
              <textarea
                name="voiceTemplate"
                value={newTemplate.voiceTemplate}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Activation Status:</label>
              <input
                type="checkbox"
                name="voiceTemplateStatus"
                checked={newTemplate.voiceTemplateStatus}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Voice Template Stage:</label>
              <select
                value={newTemplate.voiceTemplateStage}
                onChange={handleInputChange}
              >
                <option value="">Select status</option>
                <option value="Approved">Approved</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>

            <button type="submit">Create Template</button>
          </form>
        </div>
      </Modal>

      <h3>Existing Voice Templates</h3>
      {templates.length === 0 ? (
        <p>No templates available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Voice Template ID</th>
                <th>Template Name</th>
                <th>Template Category</th>
                <th>Template Body</th>
                <th>Activation Status</th>
                <th>Template Stage</th>
                <th>Created At</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {templates.map((template) => (
                <tr key={template.id}>
                  <td>{template.id}</td>
                  <td>{template.voiceTemplateId}</td>
                  <td>{template.voiceTemplateName}</td>
                  <td>{template.voiceTemplateCategory.templateCategory}</td>
                  <DataCell label="Template Body" value={template.voiceTemplate} onClick={setActiveDetails} />
                  <td>{template.voiceTemplateStatus ? 'Active' : 'Inactive'}</td>
                  <td>
                    {editingTemplate === template.id ? (
                      <select
                        value={editVoiceTemplateStage}
                        onChange={(e) => setEditSmsTemplateStage(e.target.value)}
                      >
                        <option value="">Select status</option>
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    ) : (
                      // display value when not editing (you can prettify the text)
                      template.voiceTemplateStage || "N/A"
                    )}
                  </td>
                  <td>{new Date(template.createdTimestamp).toLocaleString()}</td>
                  <td>{new Date(template.updatedTimestamp).toLocaleString()}</td>
                  <td>{template.lastUpdatedBy}</td>

                  <td>
                    <div className="action-buttons">
                      {editingTemplate === template.id ? (
                        <button onClick={() => handleEditSubmit(template.id)}>Save</button> // Save edited voice template
                      ) : (
                        <button onClick={() => handleEditClick(template)}>Edit</button> // Set voice template
                      )}
                      <button onClick={() => toggleActivationStatus(template.id, template.voiceTemplateStatus)}>
                        {template.voiceTemplateStatus ? 'Disable' : 'Enable'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
      {/* ONE MODAL TO RULE THEM ALL */}
      <CommonModal
        isOpen={!!activeDetails}
        onClose={() => setActiveDetails(null)}
        /* Pull the dynamic title from state */
        title={activeDetails?.title || "Details"}
        copyValue={activeDetails?.text}
      >
        {activeDetails?.text}
      </CommonModal>
    </div>
  );
};

export default VoiceTemplatePage;
